// ESC/POS 指令編碼器（純 JS，無外部依賴）
// 文字一律以 UTF-8 輸出，對應支援 UTF-8 的雲印表機。
// 本檔只負責「文字 → ESC/POS bytes」的低階組裝，版面邏輯放在 orderDetailEscPosBuilder.js。

const ESC = 0x1b
const GS = 0x1d
const LF = 0x0a

const ALIGN = { left: 0, center: 1, right: 2 }

function toUtf8Bytes(str) {
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder().encode(str)
  }
  // Node 環境 fallback
  return Uint8Array.from(Buffer.from(str, 'utf-8'))
}

export class EscPosEncoder {
  constructor() {
    this._bytes = []
  }

  _push(...bytes) {
    for (const b of bytes) this._bytes.push(b & 0xff)
    return this
  }

  // ESC @ 初始化
  initialize() {
    return this._push(ESC, 0x40)
  }

  // ESC a n 對齊：'left' | 'center' | 'right'
  align(mode = 'left') {
    return this._push(ESC, 0x61, ALIGN[mode] ?? 0)
  }

  // ESC E n 粗體
  bold(on = true) {
    return this._push(ESC, 0x45, on ? 1 : 0)
  }

  // GS ! n 字級放大：width/height 倍率 1~8
  size(width = 1, height = 1) {
    const w = Math.min(Math.max(width, 1), 8) - 1
    const h = Math.min(Math.max(height, 1), 8) - 1
    return this._push(GS, 0x21, (w << 4) | h)
  }

  // 純文字（UTF-8），不換行
  text(str = '') {
    const bytes = toUtf8Bytes(String(str))
    for (const b of bytes) this._bytes.push(b)
    return this
  }

  // 文字 + 換行
  line(str = '') {
    return this.text(str)._push(LF)
  }

  // 空白行
  newline(count = 1) {
    for (let i = 0; i < count; i++) this._push(LF)
    return this
  }

  // 比一整行更小的間距（約半行）：ESC 3 n 設定較小行距 feed 一次後，ESC 2 還原預設
  smallGap() {
    return this._push(ESC, 0x33, 12, LF, ESC, 0x32)
  }

  // GS V 1 切紙（partial cut）
  cut() {
    return this._push(GS, 0x56, 1)
  }

  encode() {
    return Uint8Array.from(this._bytes)
  }
}

// bytes → Base64（瀏覽器 / Node 皆可）
export function bytesToBase64(bytes) {
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(bytes).toString('base64')
  }
  let binary = ''
  const chunk = 0x8000
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk))
  }
  return btoa(binary)
}
